import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";
import { featurePaths } from "@feature/constants/paths.constant";
import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";


const MakePayment = lazy(() => import("@feature/pages/MakePayments"));
const TrackShipments = lazy(() => import("@feature/pages/TrackShipments"));
const SignUp = lazy(() => import("@feature/pages/SignUp"));
const TrackAndTracePod = lazy(() => import("@feature/pages/TrackandTracePod"));
const PrivacyPolicy = lazy(() => import("@feature/pages/PrivacyPolicy"));
const Terms = lazy(() => import("@feature/pages/Terms"));
const QuoteTermsConditions = lazy(() => import("@feature/pages/QuoteTermsConditions"));
const CookiePolicy = lazy(() => import("@feature/pages/CookiePolicy"));

@injectable()
@registry([{ token: FeatureToken, useClass: HelloWorld }])
class HelloWorld implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "Make Payment",
                path: featurePaths.MakePayment,
                page: MakePayment
            },
            {
                title: "Track Shipments",
                path: featurePaths.TrackShipments,
                page: TrackShipments
            },
            {
                title: "Sign Up",
                path: featurePaths.SignUp,
                page: SignUp
            },
            
             {
                title: "Track and Trace",
                path: featurePaths.TrackandTracePod,
                page: TrackAndTracePod
            },
            {
                title: "Privacy Policy",
                path: featurePaths.PrivacyPolicy,
                page: PrivacyPolicy
            },
            {
                title: "Terms",
                path: featurePaths.Terms,
                page: Terms
            },
            {
                title: "Quote Terms & Conditions",
                path: featurePaths.QuoteTermsConditions,
                page: QuoteTermsConditions
            },
            {
                title: "Cookie Policy",
                path: featurePaths.CookiePolicy,
                page: CookiePolicy
            },
        ]
    };
}
